export default __webpack_public_path__ + "static/climate-environmental-justice-accomplishment-4-2d1f1e8fa59b0dc05dcee60b279f4beb.webp";